import type { Movimiento } from '../lib/supabase';
import type { SaldoRestringidoCampana } from '../types/fondosCampana';

/** Nombre con el que el usuario ve un asiento del fondo restringido de una campaña. */
export function etiquetaMovimientoFondo(m: Movimiento): string {
  if (m.saldo_inicial_campana) return 'Apertura histórica';
  if (m.envio_campana_id) return m.tipo === 'ingreso' ? 'Transferencia recibida' : 'Transferencia enviada';
  if (m.aporte_campana_id) return 'Cobro monetario';
  return m.tipo === 'ingreso' ? 'Ajuste de ingreso' : 'Gasto';
}

/** Cifras de «Ver composición»: apertura + recaudación + recibidas − enviadas − gastos = saldo registrado. */
export function composicionDelFondo(fondo: SaldoRestringidoCampana): readonly (readonly [string, number])[] {
  return [
    ['Apertura histórica', fondo.saldoInicial], ['Recaudación monetaria', fondo.recaudadoMonetario],
    ['Transferencias recibidas', fondo.recibidoConfirmado], ['Transferencias enviadas', fondo.enviadoConfirmado],
    ['Gastos', fondo.otrosEgresos],
  ];
}
